const modalOpen = (state = false, action) => {
    switch(action.type) {
        case 'modalOpen':
            return action.payload;
        default:
            return state;
    }
}

export default modalOpen;